(() => {
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-bfd-copy]');
    if (!button) return;
    const status = button.closest('[data-bfd-offer]').querySelector('[role="status"]');
    try { await navigator.clipboard.writeText(button.dataset.bfdCopy); status.textContent = status.dataset.bfdCopied; }
    catch { status.textContent = button.dataset.bfdCopy; }
  });
})();

(() => {
  const source = document.querySelector('[id^="price-"] .cf-bfd-price-tag');
  const root = document.getElementById('MainContent');
  if (!source || !root) return;
  let scheduled = false;
  const sync = () => {
    scheduled = false;
    root.querySelectorAll('.tee-product-price').forEach(price => {
      if (!price.querySelector('.cf-bfd-price-tag')) price.append(source.cloneNode(true));
    });
  };
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }).observe(root, {childList: true, subtree: true});
  sync();
})();


(() => {
  const root = document.getElementById('MainContent');
  if (!root) return;
  let scheduled = false;
  const place = () => {
    scheduled = false;
    root.querySelectorAll('.product__info-container').forEach(container => {
      const offers = Array.from(container.querySelectorAll('[data-bfd-offer]'));
      const offer = offers.shift();
      offers.forEach(duplicate => duplicate.remove());
      const trust = container.querySelector('.cf-pdp-trust') || container.querySelector('.cf-info-marquee') || container.querySelector('.reassurance-marquee');
      if (!offer || !trust) return;
      let anchor = trust;
      while (anchor.parentElement && anchor.parentElement !== container) anchor = anchor.parentElement;
      if (anchor.parentElement === container && !anchor.contains(offer) && anchor.nextElementSibling !== offer) anchor.after(offer);
    });
  };
  new MutationObserver(() => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(place); }
  }).observe(root, {childList:true,subtree:true});
  place();
})();

